import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit"
import createSagaMiddleware from "redux-saga"
import rootReducer from "./reducers"
import rootSaga from "./sagas"

const sagaMiddleware = createSagaMiddleware()

// Function to initialize state from localStorage
const initializeStateFromLocalStorage = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser"))
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true"
  const userRole = authUser ? authUser.role : []
  const accountType = localStorage.getItem("accountType")
  // console.log(userRole, "index")
  return {
    Login: {
      // Using the imported authReducer as Login
      authUser: authUser || {},
      isLoggedIn,
      userRole,
      accountType,
    },
  }
}

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(sagaMiddleware),
  preloadedState: initializeStateFromLocalStorage(), // Initialize state from localStorage
  devTools: false,
})

sagaMiddleware.run(rootSaga)

export default store
